export function statusMapperListResponse(json, headers) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      unitProcessorId: resource.objectId,
    })),
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateStatusId(json) {
  return {
    data: {...json, id: json.objectId,statusId:json.objectId},
  };
}
export function fixGetManyStatus(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      categoryId: resource.objectId,
    })),
  };
}

export function fixCreateStatusId(params, json) {
  return {
    data: {...params.data, id: json.result.objectId},
  };
}

export function statusMapperGetOneResponse(json) {
  return {
    data: {...json.result, id: json.result.objectId, unitProcessorId: json.result.objectId},
  };
}